import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute , Router} from "@angular/router";
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { gutil } from '../gutil';
import { faUser , faTimes , faUsers ,faEye,faCircle, faMapMarkerAlt, faArrowRight, faHome, faLink, faMapPin, faChevronDown , faChevronUp, faCoins, faMoneyCheck, faCalendarAlt ,faBolt , faFileAlt, faMapMarker} from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';

declare var $:any;

@Component({
  selector: 'app-property-detail',
  templateUrl: './property-detail.component.html',
  styleUrls: ['./property-detail.component.scss']
})

export class PropertyDetailComponent implements OnInit {
  
  public faArrowRight = faArrowRight;
  public faTimes = faTimes;
  public faCircle = faCircle;
  public faUser = faUser;
  public faUsers = faUsers;
  public property_id: any;
  public property_data: any;
  public room_amenities: Array<any>;
  public faEye = faEye;
  public faHome = faHome;
  public faFileAlt = faFileAlt;
  public faMapMarkerAlt = faMapMarker;
  public faMoneyCheck = faMoneyCheck;
  public faBolt = faBolt;
  public faCoins= faCoins;
  public faCalendarAlt = faCalendarAlt;
  public faChevronDown =faChevronDown;
  public faChevronUp = faChevronUp;
  public faMapPin = faMapPin;
  public faLink = faLink;
  public minDate: any;
  public rooms: any;
  public testimony:Array<any>;
  public t = 0;
  public r = 0;
  public name: any;
  public isReadMore = true;
  public simprops : Array<any>;
  public property_images : any;
  public property_big_images : any;
  public scrollCounter: number =0 ;
  public scrollCounterSimProps: number =0;
  public propCity : any;
  public loader : boolean;
  public zoom= 12;
  public latitude: number;
  public longitude: number;
  public scheduleVisit = {name:"",phone:"",email:"",visitdate:"",property_id:"" , visittime:"",user_id:0};
  public minSchVisDate:any;
  public schl_msg:string;
  public submit_schl:boolean = false;
  public email_re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public phone_re = /\+?\d[\d -]{8,12}\d/;
  public schl_success:boolean = false;
  public dispDeposit:any;
  public dispRent:any;
  public dispSimPropRent:any;
  public user : any;


  constructor(private routeact: ActivatedRoute,private http: HttpClient, private router : Router) { 
    this.property_id = this.routeact.snapshot.params['property_id'];
    console.log(gutil.user);
    if(gutil.user != undefined){
      this.user = gutil.user;
    }
  }

  ngOnInit(): void {
    window.scroll(0,0)
    this.fetchPropDetail();
    // this.fetchTestimonial();
    this.loader = true;
    this.scrollCounter = 0;
    this.scrollCounterSimProps = 0;
    this.isReadMore = true;
    this.minSchVisDate = moment().add(1, 'days').format('YYYY-MM-DD');
  }
  
  public fetchPropDetail() {
    this.loader = true;
    
    this.property_images = [];
    this.property_big_images = [];
    this.http.get(gutil.apiUrl + '/api/w/v1/property/info/' + this.property_id)
        .subscribe((data: any) => {
            this.property_data = data.obj;
            let len = this.property_data.length;
            
              let tempRent = this.property_data.rent;
              tempRent = tempRent.toString();
              let lThree = tempRent.substring(tempRent.length-3);
              let oNumbers = tempRent.substring(0,tempRent.length-3);
              if(oNumbers != ''){
                lThree = ',' + lThree;
              }
              this.property_data.formatted_prop_rent = oNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lThree;


              let tempDep = this.property_data.deposite;
              tempDep = tempDep.toString();
              let x = tempDep.substring(tempDep.length-3);
              let o = tempDep.substring(0,tempDep.length-3);
              if(o != ''){
                x = ',' + x;
              }
              this.property_data.formatted_prop_dep = o.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + x;
            
            let lengthImages = this.property_data.images.length;
            for(let img = 0 ; img < lengthImages ; img++){
              if(this.property_data.images[img].size == "med"){
                this.property_images.push(this.property_data.images[img]);
              }
              if(this.property_data.images[img].size == "org"){
                this.property_big_images.push(this.property_data.images[img])
              }
            }
            let lengthPropAmen = this.property_data.amenities.length;
            for(let a = 0 ; a < lengthPropAmen ; a++){
              this.property_data.amenities[a].iconName = this.getIconName(this.property_data.amenities[a].name);
            }
            this.rooms = this.property_data.rooms;
            for (let tr = 0; tr < this.rooms.length ; tr++){
              let temp = this.rooms[tr].rent;
              temp = temp.toString();
              let lastThree = temp.substring(temp.length-3);
              let otherNumbers = temp.substring(0,temp.length-3);
              if(otherNumbers != ''){
                lastThree = ',' + lastThree;
              }
              this.rooms[tr].formatted_room_rent = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
            }
            
            this.propCity = this.property_data.city;
            this.latitude = parseFloat(this.property_data.latitude);
            this.longitude = parseFloat(this.property_data.longitude);
            // this.fetchTestimonial();
            this.getSimlarProperties();
        }) 
        
        
  }
  // public fetchTestimonial(){
  //   this.http.get(gutil.devapiUrl + '/api/w/v1/testimony/details')
  //       .subscribe((data: any) => {
  //         this.testimony = data.obj;
  //       })
    
  // }
 

  public showText() {
    
     this.isReadMore = !this.isReadMore;
     
     if(this.isReadMore == true){
      document.getElementById('prop_detail').style.height = '140px';
     }
     else{
      document.getElementById('prop_detail').style.height = 'auto';
     }
     
  }
  public getSimlarProperties(){
        // gutil.searchData.address = this.prop.locality + ", " + this.prop.city + ", " + this.prop.state + ", " + this.prop.country;
        gutil.searchData.city =this.propCity;
        this.http.get(gutil.apiUrl + '/api/w/v1/search/property?' + gutil.filterSearch())
            .subscribe((data:any) => { 
                this.simprops = data.data;
                this.loader = false;
                //////Format Rent here ////////////////
                for (let rent = 0; rent < this.simprops.length ; rent++){
                  let temp = this.simprops[rent].property.rent;
                  temp = temp.toString();
                  let lastThree = temp.substring(temp.length-3);
                  let otherNumbers = temp.substring(0,temp.length-3);
                  if(otherNumbers != ''){
                    lastThree = ',' + lastThree;
                  }
                  this.simprops[rent].property.room_rent = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
                }
            
            });
    }

    public scrollRight() {
      let len = this.property_images.length;
      if(this.scrollCounter < len){
        this.scrollCounter += 1;
        let el = document.getElementById("img_" + this.scrollCounter);
        el.scrollIntoView({behavior: 'smooth', block: 'end'});
      }else{
        this.scrollCounter = len;
      }
      
    }
    public scrollLeft() {
      if(this.scrollCounter > 0){
        this.scrollCounter -= 1;
        let el = document.getElementById("img_" + this.scrollCounter);
        el.scrollIntoView({behavior: 'smooth' , block: 'end'});
      }else{
        this.scrollCounter = 0;
      }
    }
    public scrollLeftSimProps(){
      let content = document.getElementById('spimgs');
      this.slideScroll(content,'left',25,150,320);
    }
    public scrollRightSimProps() {
      let content = document.getElementById('spimgs');
      this.slideScroll(content,'right',25,150,320);
      
    }
    public slideScroll(element : any,direction: string,speed: number,distance: number,step: number){
      let scrollAmount = 0;
      let slideTimer = setInterval(function(){
        if(direction == 'left'){
          element.scrollLeft -= step;
        }else{
          element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >=distance ){
          window.clearInterval(slideTimer);
        }
      }, speed)
    }

    public getPropAmenName(name: any){
      let nameAmen = gutil.getIconClass(name);
      return nameAmen[1];
    }
    public getIconName(name: any){
      let icon = gutil.getIconClass(name);
      return icon[0];
      
    }


    public refresh(pid: any){
      
      this.router.navigate(['/property/' + pid])
      .then(() => {
        window.location.reload();
      });
      
    }

    public schVisitShow(element: string){
      let el = document.getElementById(element);
      el.scrollIntoView({behavior: 'smooth'});
      setTimeout(() => {
        document.getElementById('svisit_head').classList.add('blink');
      }, 1000)
      document.getElementById('svisit_head').classList.remove('blink');
    }
    ////////////////////////////////////////////////// Schedule Visit Function//////////////////////////////
    public onTenName(value:any) {
      this.scheduleVisit.name = value;
    }
    public onTenEmail(value:any) {
      this.scheduleVisit.email = value;
    }
    public onTenPhone(value:any) {
      this.scheduleVisit.phone = value;
    }
    public onTenVisTime(value:any) {
      this.scheduleVisit.visittime = value;
    }
    public onTenVisDate(value:any) {
      this.scheduleVisit.visitdate = value;
    }

    public submitSchlVisit() {
      this.scheduleVisit.property_id = this.property_id;
      if(this.scheduleVisit.name != "" && this.scheduleVisit.email != "" && this.scheduleVisit.phone != ""
        && this.scheduleVisit.visitdate != "" && this.scheduleVisit.visittime != "") {
          if(this.email_re.test(this.scheduleVisit.email)) {
            if(this.phone_re.test(this.scheduleVisit.phone)) {
                console.log(this.scheduleVisit.visittime);
                let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
                let options = {headers: headers};
                let params = new URLSearchParams();
                let vdate:any;
                if(gutil.user!= undefined){
                    params.append('api_token', gutil.user.api_token);
                    this.scheduleVisit.user_id = gutil.user.id;
                }
                for(let key in this.scheduleVisit){
                  if(key!='visittime' && key!='visitdate'){
                    params.append(key, this.scheduleVisit[key]);
                  }else if(key == 'visitdate'){
                    vdate = new Date(this.scheduleVisit[key]);
                    if(vdate.getFullYear() > 2015){
                      params.append(key, vdate.getFullYear() + "-" + (vdate.getMonth()<9 ? "0"  : ""  ) + (vdate.getMonth()+1) + "-" + vdate.getDate());
                    }
                  }
                }
                if(vdate!== undefined && vdate.getFullYear() > 2015 && this.scheduleVisit.visitdate != ""){
                  if(this.scheduleVisit.visittime!=""){
                      params.append('to_time', vdate.getFullYear() + "-" + (vdate.getMonth()<9 ? "0"  : ""  ) + (vdate.getMonth()+1) + "-" + (vdate.getDate()<10 ? "0"  : ""  ) + vdate.getDate() + " " + this.scheduleVisit.visittime);
                  }
                  else{
                      params.append('to_time', vdate.getFullYear() + "-" + (vdate.getMonth()<9 ? "0"  : ""  ) + (vdate.getMonth()+1) + "-" + (vdate.getDate()<10 ? "0"  : ""  ) + vdate.getDate() + " 00:00:00");
                  }
              }
              params.append('sact',this.scheduleVisit.email);
              params.append('adv_search_id', "0");
              params.append('is_advancesearch',"0");

              let paramsString = params.toString();
              this.http.post(gutil.apiUrl + '/api/w/v1/schedule/visit/edit',paramsString, options).subscribe((data: any) => {
                if(data.data != -1){
                  this.schl_success = true;
                  this.schl_msg = "Visit scheduled. Our team will contact you shortly.";
                  this.emptyScheduleForm();
                }
              })
                // setTimeout(() => {
                //   $("#schVisitModal").modal('hide');
                //   this.emptyScheduleForm();
                // },2000)
                // this.closeVisitNotification();
            }
            else {
              this.submit_schl = true;
              this.schl_msg = "Enter a valid phone number";
              this.closeVisitNotification();
            }
          }
          else {
            this.submit_schl = true;
            this.schl_msg = "Enter a valid Email";
            this.closeVisitNotification();
          }
        }
      else {
        this.submit_schl = true;
        this.schl_msg = "All Fields Mandatory!";
        this.closeVisitNotification();
      } 
    }
    public emptyScheduleForm() {
      this.scheduleVisit.name = "";
      this.scheduleVisit.email = "";
      this.scheduleVisit.phone = "";
      this.scheduleVisit.visitdate = "";
      this.scheduleVisit.visittime = "";
    }
    public closeVisitNotification() {
      setTimeout(() => {
        this.submit_schl = false;
        this.schl_success = false;
      }, 3000)
    }
}